import React from 'react';
import { PageTitle } from '@cordata/buffet';

import Form from '~/components/FrequentCustomerRequest/Form';

const FrequentCustomerRequests = () => (
  <>
    <PageTitle>Frequent Customer Requests</PageTitle>

    <Form />
  </>
);

export default FrequentCustomerRequests;
